import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import { setErroAPI, setSuccess } from '../common/toast/toast';

const API = `${consts.API_URL}/usuarioPerfil`;

export const USUARIO_PERFIL_MODO_TELA = 'USUARIO_PERFIL_MODO_TELA';
export const USUARIO_PERFIL_SET_AGUARDANDO = 'USUARIO_PERFIL_SET_AGUARDANDO';
export const USUARIO_PERFIL_LISTADO = 'USUARIO_PERFIL_LISTADO';

export function setModoTela(modo, registro = {}) {
    return {
        type: USUARIO_PERFIL_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: USUARIO_PERFIL_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('usuarioPerfilForm', registro)
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: USUARIO_PERFIL_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const request = registro.id
                ? axios.put(API, registro)
                : axios.post(API, registro);

            await request;

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}